import React, {
  ReactNode,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react'

type ISelectedChatContext = {
  selectedChatRoomId: string | undefined
  setSelectedChatRoomId: (chatId?: string) => void
}

const SelectedChatContext = createContext<null | ISelectedChatContext>(null)

export const SelectedChatIdProvider = ({
  children,
}: {
  children?: ReactNode
}): React.ReactNode => {
  const [selectedChatRoomId, setSelectedChatRoomId] = useState<string>()

  const values = useMemo(() => {
    return {
      selectedChatRoomId,
      setSelectedChatRoomId,
    }
  }, [selectedChatRoomId, setSelectedChatRoomId])
  return (
    <SelectedChatContext.Provider value={values}>
      {children}
    </SelectedChatContext.Provider>
  )
}

export const useSelectedChatId = (): ISelectedChatContext => {
  const context = useContext(SelectedChatContext)
  if (!context) {
    throw new Error(
      'useSelectedChatId, must be used inside SelectedChatIdProvider'
    )
  }
  return context
}
